import { API_URL } from '@app/config'
import { createContext, type ReactNode, useContext } from 'react'
import { createApiClient } from './client'
import { createEndpoints, type Endpoints } from './endpoints'

const defaultEndpoints = createEndpoints(createApiClient(API_URL))
const ApiContext = createContext<Endpoints>(defaultEndpoints)

// Da acceso a la API a toda la app. En los tests se inyectan endpoints falsos.
export const ApiProvider = ({ endpoints, children }: { endpoints?: Endpoints; children: ReactNode }) => (
	<ApiContext.Provider value={endpoints ?? defaultEndpoints}>{children}</ApiContext.Provider>
)

export const useApi = (): Endpoints => useContext(ApiContext)
